import { TutorialVideo } from '../TutorialVideo';

const TUTORIALS = [
  {
    title: 'Create a parent account',
    description: 'Create the parent account, verify email, and continue to Family setup. Demo details are fictional.',
    videoSrc: '/tutorials/parent-account.mp4',
    posterSrc: '/tutorials/parent-account-poster.jpg',
    captionsSrc: '/tutorials/parent-account.vtt',
    page: '/create-account',
    pageLabel: 'Open account setup',
  },
  {
    title: 'Add a child profile',
    description: 'Add a child from Family home and continue into guided setup. Example child and phone details are fictional.',
    videoSrc: '/tutorials/add-child.mp4',
    posterSrc: '/tutorials/add-child-poster.jpg',
    captionsSrc: '/tutorials/add-child.vtt',
    page: '/',
    pageLabel: 'Open Family home',
  },
  {
    title: 'Connect Canvas for assignments',
    description: 'Enter the child’s Canvas website and masked token. This powers tasks, homework, grades, and reminders.',
    videoSrc: '/tutorials/connect-canvas.mp4',
    posterSrc: '/tutorials/connect-canvas-poster.jpg',
    captionsSrc: '/tutorials/connect-canvas.vtt',
    page: null,
    pageLabel: null,
  },
  {
    title: 'Verify a student phone or watch',
    description: 'Send and enter a one-time code so reminders and trusted voice calls can use the student number.',
    videoSrc: '/tutorials/verify-phone.mp4',
    posterSrc: '/tutorials/verify-phone-poster.jpg',
    captionsSrc: '/tutorials/verify-phone.vtt',
    page: null,
    pageLabel: null,
  },
];

export function TutorialsView() {
  return (
    <main className="tutorials-page">
      <section className="card">
        <p className="muted">Help / tutorial videos</p>
        <h1>Setup video guides</h1>
        <p>
          These videos use synthetic family, student, phone, and school data. Use them as quick walkthroughs for the
          current Student Assistant setup screens.
        </p>
      </section>
      <section className="tutorial-library" aria-label="Tutorial videos">
        {TUTORIALS.map((tutorial) => (
          <article className="card tutorial-library-card" key={tutorial.videoSrc}>
            <TutorialVideo {...tutorial} />
            <div className="row">
              <a href={tutorial.videoSrc} target="_blank" rel="noopener noreferrer">Open video file</a>
              {tutorial.page && tutorial.pageLabel && <a href={tutorial.page}>{tutorial.pageLabel}</a>}
            </div>
          </article>
        ))}
      </section>
    </main>
  );
}
